import React from 'react';

const MainContent = ({ children }) => (
    // --- INÍCIO DA CORREÇÃO ---
    // Adicionado padding-top (pt-16) para compensar a altura da Navbar fixa (h-16)
    <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in">
            {children}
        </div>
    </main>
    // --- FIM DA CORREÇÃO ---
);

export default MainContent;